import React,{useState, useEffect} from 'react';
import axios from 'axios';

import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';


const ListadoPaciente = () => {
    const baseUrl="//localhost/";
  
    const [data, setData]=useState([]);
    const [modalInsertar, setModalInsertar]=useState(false);
    const [modalEditar, setModalEditar]=useState(false);
    const [modalRestablecer, setModalRestablecer]=useState(false);
    const [modalEliminar, setModalEliminar]=useState(false);

    const [pacienteSeleccionado, setinsertPaciente]= useState({
        id:'',
        nombre:'',
        Apellido:'',    
        DNI:'',
        tipoOperador:'',
        sexo:'',
        fechaNacimiento:'',
        email:'',
        telefono:'',
        user:'',
        pass:'',
        telefono:''
    });

    const handleChange=e=>{
        const {name,value}=e.target;
        setinsertPaciente((prevestate)=>({
            ...prevestate,
            [name]: value
        }))
       
    }


   const abrirModalInsertar=()=>{
        setModalInsertar(!modalInsertar);
    }

    
   const abrirModalEditar=()=>{
    setModalEditar(!modalEditar);
    }

    const abrirModalRestablecer=()=>{
        setModalRestablecer(!modalRestablecer);
        }
    
    const abrirModalEliminar=()=>{
        setModalEliminar(!modalEliminar);
        }

    const peticionGet=async()=>{
            
        await axios.get(baseUrl,{params:{opcion: 'Pacientes'}})
        .then(response=>{
          setData(response.data);
        }).catch(error=>{
          console.log(error);
        })
      }

    


    
    const peticionPost=async()=>{
        var f = new FormData();
        f.append("nombre", pacienteSeleccionado.nombre);
        f.append("apellido", pacienteSeleccionado.Apellido);
        f.append("numeroIdentificacion", pacienteSeleccionado.DNI);
        f.append("TipoOperador", pacienteSeleccionado.tipoOperador);
        f.append("sexo", pacienteSeleccionado.sexo);
        f.append("fechaNacimiento", pacienteSeleccionado.fechaNacimiento);
        f.append("email", pacienteSeleccionado.email);
        f.append("telefono", pacienteSeleccionado.telefono);
        f.append("user", pacienteSeleccionado.user);
        f.append("password", pacienteSeleccionado.pass);
        f.append('METHOD', 'POST');
        await axios.post(baseUrl,f)
        .then(response=>{
            setData(data.concat(response.data));
            console.log(response.data);
            abrirModalInsertar();
       }).catch(error=>{
        console.log(error);
    })
    }

    const peticionPut=async()=>{
        var f = new FormData();
        f.append("nombre", pacienteSeleccionado.nombre);
        f.append("apellido", pacienteSeleccionado.Apellido);
        f.append("numeroIdentificacion", pacienteSeleccionado.DNI);
        f.append("METHOD", "PUT");
        await axios.post(baseUrl,f,{params:{id: pacienteSeleccionado.id}})
        .then(response=>{
           var dataNueva=data;
           dataNueva.map(pacientee=>{
               if(pacientee.id===pacienteSeleccionado.id){
                   pacientee.nombre = pacienteSeleccionado.nombre;
                   pacientee.apellido = pacienteSeleccionado.Apellido;
                   pacientee.DNI = pacienteSeleccionado.DNI;
               }
           });
           setData(dataNueva);
            abrirModalEditar();
       }).catch(error=>{
        console.log(error);
    })
    }


    const peticionDelete=async()=>{
        var f = new FormData();
        f.append("METHOD", "DELETE");
        await axios.post(baseUrl,f, {params:{id: pacienteSeleccionado.id}})
        .then(response=>{
            setData(data.filter(paciente=>paciente.id!==pacienteSeleccionado.id));
            abrirModalEliminar();
       }).catch(error=>{
           console.log(error);
       })
    }


    const seleccionPac=(paciente, caso)=>{
        setinsertPaciente(paciente);
       (caso==="Editar") ?
        abrirModalEditar():
        abrirModalEliminar()
    }

    useEffect(()=>{
       
      peticionGet();
       
    },[])


    return(
        <div>
            <br></br>
            <h3><p className="text-info">Listado de  Pacientes/Derivante</p> </h3>
            <br></br>
            <button className="btn btn-outline-primary"
            onClick={()=>abrirModalInsertar()}
            >Insertar Nuevo</button>
             <button className="btn btn-outline-info"
           
            >Volver</button>
           
            <table className="table table-hover">
                <thead>
                    <th>Nombre</th>
                    <th>Apellido</th>
                    <th>Correo</th>
                    <th>Tipo Identidad</th>
                    <th>Acciones</th>
                    <th></th>
                </thead>
       
            <tbody>
                {data.map(paciente=>(
                    <tr key={paciente.id}>
                    <td> {paciente.nombre}</td>
                    <td> {paciente.apellido}</td>
                    <td> {paciente.email}</td>
                    <td> {paciente.TipoOperador}</td>
                    <td>
                        <button className="btn btn-link" onClick={()=>seleccionPac(paciente,"Editar")}>
                            <span className="input-group-text" id="basic-addon">
                            <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                            </span>  </button>
                        <button className="btn btn-link"  onClick={()=>seleccionPac(paciente,"Eliminar")}>
                        <span className="input-group-text" id="basic-addon">
                        <i className="fa fa-trash-o" aria-hidden="true"></i>
                            </span> </button>
                        <button className="btn btn-link"  onClick={abrirModalRestablecer}>
                        <span className="input-group-text" id="basic-addon">
                        <i className="fa fa-key" aria-hidden="true"></i>
                            </span> 
                        </button>
                    </td>
 
 
                    </tr>
                ))}
            </tbody>
            </table>

         <Modal isOpen={modalInsertar}>
                    <ModalHeader><p className="text-info">Nuevo Pacientes/Derivante</p></ModalHeader>
                    <ModalBody>
                        <div className="form-group">
                        <label>Nombre: </label>
                        <input type="text" className="form-control" name="nombre" onChange={handleChange}/>
                        <label>Apellido: </label>
                        <input type="text" className="form-control" name="Apellido" onChange={handleChange}/>
                        <label>DNI </label>
                        <input type="text" className="form-control" name="DNI" onChange={handleChange}/>
                       
                        <label >Sexo</label>
                            <select className="form-control" id="sexoselect" name="sexo" onChange={handleChange} >
                                <option>Masculino</option>
                                <option>Femenino</option>
                                <option>Sin Declarar</option>
                        </select>
                        <label >Tipo Usuario</label>
                            <select className="form-control" id="usuarioSelect" name="tipoOperador" onChange={handleChange}>
                                <option>Paciente</option>
                                <option>Derivante</option>
                        </select>
           
                        <label >Fecha Nacimiento</label>
                        <input className="form-control" type="date"  name="fechaNacimiento" onChange={handleChange} ></input>

                       <label>Email</label>
                        <input className="form-control" type="email" name="email" onChange={handleChange}></input>

                        <label >Telefono</label>
                        <input className="form-control" type="tel" name="telefono" onChange={handleChange}></input>
                   </div>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-primary" onClick={()=>peticionPost()}>Grabar</button>{"   "}
                        <button className="btn btn-info" onClick={abrirModalInsertar}>Cancelar</button>
                      
                    </ModalFooter>
            </Modal>

            <Modal isOpen={modalEditar}>
            <ModalHeader><p className="text-info">Editar </p></ModalHeader>
                    <ModalBody>
                        <div className="form-group">
                        <label>Nombre: </label>
                        <input type="text" className="form-control" name="nombre" onChange={handleChange} values={pacienteSeleccionado && pacienteSeleccionado.nombre}/>
                        <label>Apellido: </label>
                        <input type="text" className="form-control" name="Apellido" onChange={handleChange} values={pacienteSeleccionado && pacienteSeleccionado.Apellido}/>
                        <label>DNI </label>
                        <input type="text" className="form-control" name="DNI" onChange={handleChange} values={pacienteSeleccionado && pacienteSeleccionado.DNI}/>
                        <label>Habilitado </label>
                        <input type="checkbox" className="form-control" name="habilitado" onChange={handleChange} values={pacienteSeleccionado && pacienteSeleccionado.DNI}/>
                       
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn-outline-primary" onClick={()=>peticionPut()}>Editar</button>{"   "}
                        <button className="btn-outline-danger" onClick={abrirModalEditar}>Cancelar</button>
                    </ModalFooter>
            </Modal>

            <Modal isOpen={modalRestablecer}>
            <ModalHeader><p className="text-info">Restablecer Contraseña</p></ModalHeader>
                    <ModalBody>
                        <div className="form-group">
                        <label for="exampleInputPassword1">Password</label>
                        <input type="password" className="form-control" id="exampleInputPassword1" />
                        <label for="exampleInputPassword2">Repetir Password</label>
                        <input type="password" className="form-control" id="exampleInputPassword2" />
                                      



                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn-outline-primary" >Guardar</button>{"   "}
                        <button className="btn-outline-danger"onClick={abrirModalRestablecer}>Cancelar</button>
                    </ModalFooter>
            </Modal>


            <Modal isOpen={modalEliminar}>
                    <ModalBody>
                    Desea Eliminar el Paciente ? {pacienteSeleccionado && pacienteSeleccionado.nombre}
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn-outline-primary" onClick={abrirModalEliminar}>No</button>{"   "}
                        <button className="btn-outline-danger" onClick={()=>peticionDelete()}>SI</button>
                    </ModalFooter>
            </Modal>


        </div>
    );

}

export default ListadoPaciente;